module.exports = __webpack_public_path__ + "static/img/whatsapp-back.adbccee0.png";